import React, { useState, useEffect } from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';
import SimpleSlider from '../components/SimpleSlider';
import Slider from 'react-slick';

export default () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <Layout>
      {/* Hero Section Modernizada */}
      <section className="relative pt-12 md:pt-24 pb-12 md:pb-20 overflow-hidden bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900">
        {/* Background com gradiente moderno */}
        {/* <div className="absolute inset-0 bg-gradient-to-br from-gray-900/50 via-purple-900/50 to-indigo-900/50"></div> */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/20 to-purple-600/20"></div>
        </div>
        
        {/* Animações de fundo */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
          <div className="absolute top-40 right-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-20 w-72 h-72 bg-indigo-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
        </div>

        <div className="container mx-auto px-8 lg:flex relative z-10">
          <div className={`text-center lg:text-left lg:w-1/2 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-full text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
              Transformando ideias em realidade digital
            </div>
            
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight bg-gradient-to-r from-white via-purple-200 to-blue-200 bg-clip-text text-transparent mb-6 text-left">
              Nós construímos sistemas e apps que impulsionam seu negócio.
            </h1>
            
            <p className="text-xl lg:text-2xl mt-6 font-light text-gray-300 mb-8">
              Maximize o potencial de seu negócio com sistemas de alto desempenho, construídos com as
              tecnologias mais recentes e inovadoras.
            </p>
            
            {/* <div className="mt-8 md:mt-12 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6">
              <a href="mailto:contato@oxton.com.br?Subject=Contato">
                <Button size="lg" className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-300">
                  Vamos lá!
                </Button>
              </a>
              <a href="#portfolio" className="px-8 py-4 border-2 border-purple-600 text-purple-600 rounded hover:bg-purple-600 hover:text-white transition-all duration-300 transform hover:scale-105">
                Ver nossos trabalhos
              </a>
            </div>
            
            <p className="mt-4 text-gray-400">Iremos te orientar nos próximos passos</p> */}
          </div>
          
          <div className={`lg:w-1/2 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <HeroImage />
          </div>
        </div>
      </section>

      {/* Seção de Tecnologias Modernizada */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900 relative overflow-hidden">
        
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/20 to-purple-600/20"></div>
        </div>
        
        <div className="container mx-auto text-center relative z-10">
          <div className="mb-16">
            <h2 className="text-3xl lg:text-5xl font-semibold text-white mb-4 text-center">
              Tecnologias que Utilizamos
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Trabalhamos com as tecnologias mais modernas e inovadoras do mercado
            </p>
          </div>
          
          <div className="flex justify-center items-center" style={{ height: '200px' }}>
            <SimpleSlider />
          </div>
        </div>
      </section>

      {/* Seção de Expertise Modernizada */}
      <section id="features" className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto text-center">
          <div className="mb-16">
            <h2 className="text-3xl lg:text-5xl font-semibold text-center bg-gradient-to-r from-gray-900 to-purple-800 bg-clip-text text-transparent">
              Nossa Expertise
            </h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Combinamos criatividade, tecnologia e metodologias ágeis para entregar soluções excepcionais
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
            <div className="group">
              <Card className="mb-8 hover:shadow-2xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm h-full flex flex-col">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <p className="font-semibold text-xl">Product Design Sprint</p>
                <p className="mt-4 text-gray-600 flex-grow">
                  Com a abordagem do Design Sprint e do Design Thinking, ajudamos nossos clientes a
                  projetar as melhores soluções digitais para seus negócios, tecnologicamente
                  possíveis e financeiramente viáveis.
                </p>
              </Card>
            </div>
            
            <div className="group">
              <Card className="mb-8 hover:shadow-2xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm h-full flex flex-col">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-500 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
                  </svg>
                </div>
                <p className="font-semibold text-xl">UX / UI</p>
                <p className="mt-4 text-gray-600 flex-grow">
                  Usando da inovação impulsionada pela criatividade, desenhamos a melhor experiência
                  para o usuário (UX), com design que favorece o uso das soluções desenvolvidas (UI),
                  ambos alinhados com os objetivos do projeto.
                </p>
              </Card>
            </div>
            
            <div className="group">
              <Card className="mb-8 hover:shadow-2xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm h-full flex flex-col">
                <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <p className="font-semibold text-xl">Squad Agile e DevOps</p>
                <p className="mt-4 text-gray-600 flex-grow">
                  Combinamos o uso de métodos ágeis com uma equipe altamente capacitada e motivada.
                  Essa união de fatores garante a agilidade e a efetividade de nossas entregas.
                </p>
              </Card>
            </div>
            
            <div className="group">
              <Card className="mb-8 hover:shadow-2xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm h-full flex flex-col">
                <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <p className="font-semibold text-xl">Manutenção e Sustentação</p>
                <p className="mt-4 text-gray-600 flex-grow">
                  Cuidamos de cada etapa do seu projeto: apoiamos sua empresa durante todo o ciclo de
                  vida do produto, desde o desenvolvimento até a sustentação e manutenção.
                </p>
              </Card>
            </div>
          </div>
        </div>
      </section>

      <section id="stats" className="py-20 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600">
        <div className="container mx-auto text-center">
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="text-white">
              <div className="text-4xl md:text-5xl font-bold mb-2">50+</div>
              <div className="text-lg opacity-90">Projetos Entregues</div>
            </div>
            <div className="text-white">
              <div className="text-4xl md:text-5xl font-bold mb-2">100%</div>
              <div className="text-lg opacity-90">Satisfação dos Clientes</div>
            </div>
            <div className="text-white">
              <div className="text-4xl md:text-5xl font-bold mb-2">24/7</div>
              <div className="text-lg opacity-90">Suporte Técnico</div>
            </div>
          </div>
        </div>
      </section>

      <section id="portfolio" className="py-20 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-5xl font-semibold text-center bg-gradient-to-r from-gray-900 to-purple-800 bg-clip-text text-transparent">
              Nossos Trabalhos
            </h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Conheça alguns dos projetos que desenvolvemos para nossos clientes
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "E-commerce Moderno",
                description: "Plataforma completa de vendas online com integração de pagamentos",
                tech: ["React", "Node.js", "MongoDB"],
                image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop"
              },
              {
                title: "App de Gestão",
                description: "Sistema de gestão empresarial com dashboard interativo",
                tech: ["Vue.js", "Python", "PostgreSQL"],
                image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop"
              },
              {
                title: "Portal Corporativo",
                description: "Portal web responsivo para empresa de grande porte",
                tech: ["Angular", "Java", "MySQL"],
                image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=300&fit=crop"
              }
            ].map((project, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
                  <div className="relative overflow-hidden h-48">
                    <img 
                      src={project.image} 
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                    <p className="text-gray-600 mb-4">{project.description}</p>
                    <div className="flex flex-wrap gap-2">
                      {project.tech.map((tech, techIndex) => (
                        <span key={techIndex} className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-sm">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="partners" className="py-20 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-5xl font-semibold text-center bg-gradient-to-r from-gray-900 to-purple-800 bg-clip-text text-transparent">
              Parceiros
            </h2>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Empresas que confiam em nosso trabalho e expertise
            </p>
          </div>
          
          <div className="relative" style={{ height: '200px' }}>
            <Slider
              dots={false}
              infinite={true}
              speed={8000}
              slidesToShow={5}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={0}
              cssEase="linear"
              responsive={[
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                  }
                }
              ]}
            >
              {/* All Nations */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/logo-allnations.png')} 
                    alt="All Nations"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">All Nations</h3>
              </div>

              {/* Golden Cross */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/golden-cross-logo.png')} 
                    alt="Golden Cross"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">Golden Cross</h3>
              </div>

              {/* Mania Virtual */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/logo-maniavirtual.png')} 
                    alt="Mania Virtual"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">Mania Virtual</h3>
              </div>

              {/* Academia de Especialistas */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/logo_academiadeespecialistas.png')} 
                    alt="Academia de Especialistas"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">Academia de Especialistas</h3>
              </div>

              {/* UERJ */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/Logo_UERJ.png')} 
                    alt="UERJ"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">UERJ</h3>
              </div>

              {/* GPA */}
              <div className="px-4">
                <div className="w-32 h-32 bg-white rounded-lg shadow-lg flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 p-4">
                  <img 
                    src={require('../images/clientes_parceiros/logo-gpa-grupo-pao-de-acucar-512.png')} 
                    alt="GPA Grupo Pão de Açúcar"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 text-center mt-4">GPA</h3>
              </div>
            </Slider>
          </div>
        </div>
      </section>
    </Layout>
  );
};
